import { createFileRoute } from "@tanstack/react-router";
import { SpringsLandingPage, buildSpringsLandingHead } from "@/components/SpringsLandingPage";
import { getSpringsLandingConfig } from "@/lib/springsLandingData";

const CONFIG = getSpringsLandingConfig("colorado-springs-real-estate-agent-seo");

export const Route = createFileRoute("/colorado-springs-real-estate-agent-seo")({
  head: () => buildSpringsLandingHead(CONFIG),
  component: () => <SpringsLandingPage config={CONFIG} />,
});
